import { api } from "../../api/api";
import { IAuthContext } from "../../contexts/AuthProvider";
import { ICompanyOutlet } from "../../redux/companyOutlet/companyOutlet.types";

import {
  getBillingCompanyFromStorage,
  saveBillingCompanyInStorage,
} from "./BillingCompanyProvider.storage";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";

export const fetchBillingCompanyInfoAsync = (
  affilated_company_outlet_uuids: IAuthContext["user"]["affilated_company_outlet_uuids"],
) =>
  new Promise<IBillingCompanyContextState | null>(async (resolve, reject) => {
    try {
      let company_outlet_uuid = null;
      const currentComapnyInfo = getBillingCompanyFromStorage();

      if (affilated_company_outlet_uuids?.length > 0) {
        try {
          const hasValidComapny = affilated_company_outlet_uuids.find(
            (company) =>
              company.company_outlet_uuid ===
              currentComapnyInfo?.company_outlet_uuid,
          );

          if (hasValidComapny) {
            company_outlet_uuid = hasValidComapny.company_outlet_uuid;
          } else {
            company_outlet_uuid = affilated_company_outlet_uuids[0].company_outlet_uuid;
          }
        } catch (error) {
          console.error("Error processing company info from storage:", error);
          // Fallback to first company if available
          if (affilated_company_outlet_uuids[0]) {
            company_outlet_uuid =  affilated_company_outlet_uuids[0].company_outlet_uuid;
          }
        }
      }
      
      if (currentComapnyInfo && affilated_company_outlet_uuids?.length === 0 ) {
        company_outlet_uuid = currentComapnyInfo.company_outlet_uuid
      }

      if (!company_outlet_uuid) {
        return resolve(null);
      }

      const companyRes = await api.get(
        `/dataManagement/get-company-outlet?company_outlet_uuid=${company_outlet_uuid}`,
      );

      const comapnyInfo = companyRes.data.data as ICompanyOutlet[];

      if (!comapnyInfo || comapnyInfo.length === 0) {
        return resolve(null);
      }

      resolve({ comapny: comapnyInfo[0] });
    } catch (error) {
      console.error("Error fetching billing company info:", error);
      resolve(null);
    }
  });
